<template>
     <vs-dialog full-screen prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
              Seguimiento de cobranza
          </h4>
        </template>
        <div class="con-form fullScreenModal">
            <div>
                <div class="mb-3 d-flex">
                    <h5>Alumno: <strong>{{selectRow.nombre}}</strong></h5>
                    <h5 class="ml-3" style="border-bottom: 2px solid #cd6155">Monto vencido: <strong>{{sumarTotal(selectRow.cargos) | currency}}</strong></h5>
                </div>
                <vs-row>
                    <vs-col>
                        <h6>Detalles de cartera vencida actual.</h6>
                    </vs-col>
                    <vs-col class="p-2" sm="12" lg="3" v-for="(cargos, c) in visibleItems" :key="c">
                        <div class="border-derecho" style="font-size: 12px; color:#626567">
                            <p class="mb-0">Código de detalle: <strong>{{cargos.codigoDetalle}}</strong></p>
                            <p class="mb-0">Fecha de vencimiento: <strong>{{cargos.fecha.fechaVencimiento}}</strong></p>
                            <p class="mb-0">Monto vencido: <strong>{{cargos.saldoPendiente | currency}}</strong></p>
                        </div>
                    </vs-col>
                    <vs-col>
                        <!-- Botón para mostrar más, solo visible si hay más de 5 elementos -->
                        <p class="verCargos mt-4" v-if="showMore" @click="showAllItems">Ver más</p>
                        <p class="verCargos mt-4" v-if="showLess" @click="showLessItems">Ver menos</p>
                    </vs-col>
                </vs-row>
                <hr>
                <vs-row>
                    <vs-col sm="12" lg="3">
                        <h6 class="mb-0 pl-3">Motivo de deuda</h6>
                        <vs-select placeholder="Motivo de deuda" v-model="motivo_deuda">
                            <vs-option label="Enfermedad" value="Enfermedad">
                                Enfermedad
                            </vs-option>
                            <vs-option label="Desempleado" value="Desempleado">
                                Desempleado
                            </vs-option>
                            <vs-option label="Se le olvidó fecha de pago" value="Se le olvidó fecha de pago">
                                Se le olvidó fecha de pago
                            </vs-option>
                            <vs-option label="Cambio de residencia" value="Cambio de residencia">
                                Cambio de residencia
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <h6 class="mb-0 pl-3">Fecha compromiso</h6>
                        <vs-input
                        
                            type="date"
                            v-model="fecha_compromiso"
                        />
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <h6 class="mb-0 pl-3">Medio de comunicación</h6>
                        <vs-select placeholder="Medio de comunicación" v-model="medio_comunicacion">
                            <vs-option label="Llamada" value="Llamada">
                                Llamada
                            </vs-option>
                            <vs-option label="Reunión" value="Reunión">
                                Reunión
                            </vs-option>
                            <vs-option label="Correo electrónico" value="Correo electrónico">
                                Correo electrónico
                            </vs-option>
                            <vs-option label="WhatsApp" value="WhatsApp">
                                WhatsApp
                            </vs-option>
                            <vs-option label="SMS" value="SMS">
                                SMS
                            </vs-option>
                            <vs-option label="Otro" value="Otro">
                                Otro
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col v-if="medio_comunicacion == 'Otro'" sm="12" lg="3">
                        <h6 class="mb-0 pl-3">Escriba el medio de comunicación</h6>
                        <vs-input v-model="medio_comunicacion_otro" placeholder="Escriba el medio de comunicación" />
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <h6 class="mb-0 pl-3">Resultado</h6>
                        <vs-select placeholder="Resultado" v-model="resultado">
                            <vs-option label="Realizó pago" value="Realizó pago">
                                Realizó pago
                            </vs-option>
                            <vs-option label="Compromiso de pago" value="Compromiso de pago">
                                Compromiso de pago
                            </vs-option>
                            <vs-option label="No contesto" value="No contesto">
                                No contesto
                            </vs-option>
                            <vs-option label="No asistió" value="No asistió">
                                No asistió
                            </vs-option>
                            <vs-option label="Rechazo deuda" value="Rechazo deuda">
                                Rechazo deuda
                            </vs-option>
                            <vs-option label="Solicita aclaración" value="Solicita aclaración">
                                Solicita aclaración
                            </vs-option>
                            <vs-option label="Se realizó negociación" value="Se realizó negociación">
                                Se realizó negociación
                            </vs-option>
                        </vs-select>
                    </vs-col>
                </vs-row>
                <div class="mt-2">
                    <h6>Añadir comentario</h6>
                    <textarea></textarea>
                    <vs-button
                        success
                        class="ml-auto"
                        @click="getGuardarSeguimientoCobranza()">
                        Enviar
                    </vs-button>
                </div>
            </div>
            <h6 class="mt-5">Seguimiento</h6>
            <div v-for="(seguimiento, c) in seguimiento_cobranza" :key="c">
                <div class="mb-2 p-2" :class="seguimiento.gestor_sigem ? 'gestorSigem' : ''">
                    <div class="d-flex justify-content-start">
                        <div>
                            <vs-avatar v-if="!seguimiento.gestor_sigem">
                                <template #text>
                                {{seguimiento.nombre_informador}}
                                </template>
                            </vs-avatar>
                            <vs-avatar v-else color="#1b3966">
                                <img src="https://sigem.maristas.edu.mx/build/images/sigem-logo.png" alt="">
                            </vs-avatar>
                        </div>
                        <div class="pl-3" style="width: 100%;">
                            <vs-row class="align-items-center">
                                <vs-col sm="12" lg="8">
                                    <p class="mb-1"><strong>{{seguimiento.nombre_informador}}</strong> <i>({{seguimiento.fecha_actualizacion}})</i></p>
                                </vs-col>
                                <vs-col sm="12" lg="4">
                                    <div class="d-flex justify-content-end">
                                        <p :class="seguimiento.gestor_sigem ? 'adminContenido p-1' : 'p-1'" :style="seguimiento.gestor_sigem ? 'border: 1px solid #28b463; border-radius: 7px;' : 'border: 1px solid #cd6155; border-radius: 7px;'"><i>{{seguimiento.gestor_sigem ? 'Abono:' : 'Monto vencido:'}} </i><strong> 
                                            <span v-if="seguimiento.gestor_sigem">
                                                {{seguimiento.abono | currency}}
                                            </span>
                                            <span v-else>
                                                {{seguimiento.monto_vencido | currency}}
                                            </span>
                                            </strong></p>
                                    </div>
                                </vs-col>
                            </vs-row>
                                    
                            <ul v-if="!seguimiento.gestor_sigem" class="d-flex gap-2 flex-wrap list-unstyled mb-4">
                                <li>
                                    <span class="bg-dark-subtle badge text-dark">{{seguimiento.motivo_deuda}}</span>
                                </li>
                                <li>
                                    <span class="bg-dark-subtle badge text-dark"><small>FECHA COMPROMISO: </small>{{seguimiento.fecha_compromiso}}</span>
                                </li>
                                <li>
                                    <span class="bg-dark-subtle badge text-dark">{{seguimiento.medio_comunicacion}}</span>
                                </li>
                                <li>
                                    <span :class="coloresEstatusResultado(seguimiento.resultado)" class="badge text-dark">{{seguimiento.resultado}}</span>
                                </li>
                            </ul>
                            <ul class="d-flex gap-2 flex-wrap list-unstyled mb-4">
                                <li>
                                    <span :class="seguimiento.gestor_sigem ? 'bg-white-subtle' : 'bg-dark-subtle'" class="badge text-dark">{{seguimiento.institucion}}</span>
                                </li>
                                <li>
                                    <span :class="seguimiento.gestor_sigem ? 'bg-white-subtle' : 'bg-dark-subtle'" class="badge text-dark">{{seguimiento.ciclo_escolar}}</span>
                                </li>
                                <li>
                                    <span :class="seguimiento.gestor_sigem ? 'bg-white-subtle' : 'bg-dark-subtle'" class="badge text-dark">{{seguimiento.programa}}</span>
                                </li>
                                <li>
                                    <span :class="seguimiento.gestor_sigem ? 'bg-white-subtle' : 'bg-dark-subtle'" class="badge text-dark">{{seguimiento.grado}}</span>
                                </li>
                                <li>
                                    <span :class="seguimiento.gestor_sigem ? 'bg-white-subtle' : 'bg-dark-subtle'" class="badge text-dark">{{seguimiento.grupo}} [{{seguimiento.no_lista}}]</span>
                                </li>
                                <li>
                                    <span :class="coloresEstatus(seguimiento.registro_academico)" class="badge text-dark">{{seguimiento.registro_academico}}</span>
                                </li>
                            </ul>
                            <div :class="seguimiento.gestor_sigem ? 'gestorSigemContenido adminContenido' : ''" class="p-3" :style="seguimiento.gestor_sigem ? '' : 'background: #f2f3f4; border-radius: 7px;'">
                                <p v-if="seguimiento.gestor_sigem" class="mb-0"><i>Gestor SIGEM informa que se ha registrado un abono de <strong>{{ seguimiento.abono | currency }}</strong> en el estado de cuenta de <strong>RUIZ FEDERICO DARANI.</strong></i></p>
                                <p v-else class="mb-0"><i>{{seguimiento.comentario}}</i></p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </div>
      </vs-dialog>
</template>

<script>
import reportes from '../../../../../api/requests/reportes.js'
export default {
    props:[
      'value',
      'selectRow'
    ],
    data () {
        return {
            active: false,
            montoVencido: 0,
            seguimiento_cobranza: [],
            medio_comunicacion: '',
            resultado: '',
            motivo_deuda: '',
            fecha_compromiso: '',
            medio_comunicacion_otro: '',
            showAll: false, // Controla si se deben mostrar todos los divs
        }
    },
    computed: {
        visibleItems() {
        // Si showAll es true, mostramos todos los elementos; si es false, solo los primeros 5
            if(this.selectRow && this.selectRow.cargos){
                const datos = Object.values(this.selectRow.cargos)
                return this.showAll ? datos : datos.slice(0, 8);
            }
        },
        showMore() {
        // Solo mostramos el botón si hay más de 5 elementos
            if(this.selectRow && this.selectRow.cargos){
                const datos = Object.values(this.selectRow.cargos)
                return datos.length > 5 && !this.showAll;
            }
        },
        showLess() {
            // Mostramos el botón "Mostrar menos" solo cuando se están mostrando todos los elementos
            if(this.selectRow && this.selectRow.cargos){
                const datos = Object.values(this.selectRow.cargos)
                return datos.length > 5 && this.showAll;
            }
        }
    },
    methods: {
        showAllItems() {
            this.showAll = true; // Muestra todos los divs
        },
        showLessItems() {
            this.showAll = false; // Vuelve a mostrar solo los primeros 5 divs
        },
        sumarTotal(datos){
            if(datos){
                const cargos = Object.values(datos)
                let suma = 0
                cargos.forEach(i => {
                    suma += i.saldoPendiente
                })
                return suma
            }
        },
        coloresEstatus(estatus){
            if(['Inscrito económico','Reactivación'].includes(estatus)){
                return 'bg-success-subtle'
            }else if(['Congelado'].includes(estatus)){
                return 'bg-warn-subtle'
            }else if(this.estatusBaja.includes(estatus)){
                return 'bg-danger-subtle'
            }else{
                return 'bg-info-subtle'
            }
        },
        coloresEstatusResultado(estatus){
            if(['Realizó pago','Compromiso de pago'].includes(estatus)){
                return 'bg-success-subtle'
            }else if(['No contesto', 'No asistió'].includes(estatus)){
                return 'bg-warn-subtle'
            }else if(['Rechazo deuda'].includes(estatus)){
                return 'bg-danger-subtle'
            }else{
                return 'bg-info-subtle'
            }
        },
        getGuardarSeguimientoCobranza(){
            console.log('getGuardarSeguimientoCobranza')
        },
        getSeguimientoCobranza(){
            console.log('getSeguimientoCobranza')

            this.seguimiento_cobranza = [
                {
                    "nombre_informador": "Carmen García",
                    "fecha_actualizacion": "12 de septiembre de 2024",
                    "monto_vencido":"28640",
                    "motivo_deuda": "Se le olvidó fecha de pago",
                    "fecha_compromiso": "16-10-2024",
                    "medio_comunicacion": "Correo electrónico",
                    "resultado": "Compromiso de pago",
                    "institucion": "INSTITUTO MEXICO SECUNDARIA (POPO)",
                    "ciclo_escolar": "Ciclo escolar 2024 - 2025",
                    "programa": "Nuevo Modelo Educativo de Educación Básica",
                    "grado": "Grado (Año) 1",
                    "grupo": "13-C",
                    "no_lista": "34",
                    "registro_academico": "Inscrito económico",
                    "comentario": "Lorempsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
                    "gestor_sigem": false,
                    "abono": ""
                },
                {
                    "nombre_informador": "Gestor SIGEM",
                    "fecha_actualizacion": "11 de septiembre de 2024",
                    "monto_vencido":"",
                    "motivo_deuda": "",
                    "fecha_compromiso": "",
                    "medio_comunicacion": "",
                    "resultado": "",
                    "institucion": "INSTITUTO MEXICO SECUNDARIA (POPO)",
                    "ciclo_escolar": "Ciclo escolar 2024 - 2025",
                    "programa": "Nuevo Modelo Educativo de Educación Básica",
                    "grado": "Grado (Año) 1",
                    "grupo": "13-C",
                    "no_lista": "34",
                    "registro_academico": "Inscrito económico",
                    "comentario": "",
                    "gestor_sigem": true,
                    "abono": "10630"
                },
                {
                    "nombre_informador": "Irma Carranza",
                    "fecha_actualizacion": "10 de septiembre de 2024",
                    "monto_vencido":"39270",
                    "motivo_deuda": "Cambio de residencia",
                    "fecha_compromiso": "15-10-2024",
                    "medio_comunicacion": "WhatsApp",
                    "resultado": "Rechazo deuda",
                    "institucion": "INSTITUTO MEXICO SECUNDARIA (POPO)",
                    "ciclo_escolar": "Ciclo escolar 2024 - 2025",
                    "programa": "Nuevo Modelo Educativo de Educación Básica",
                    "grado": "Grado (Año) 1",
                    "grupo": "13-C",
                    "no_lista": "34",
                    "registro_academico": "Inscrito económico",
                    "comentario": "Lorempsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
                    "gestor_sigem": false,
                    "abono": ""
                }
            ]
        }
     },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        selectRow(){
            this.getSeguimientoCobranza()
        },
        medio_comunicacion(){
            if(this.medio_comunicacion != 'Otro'){
                this.medio_comunicacion_otro = ''
            }
        }
    }
}
</script>
<style scoped>
.verCargos{
    color: #4988e5;
    text-decoration: underline; 
    font-weight: bold;
    cursor: pointer;
    text-align: end;
}
.dividerLine {
  width: 100%;
  border-bottom: 1px solid #ddd;
}

.gestorSigem{
    background: #ebf5fb;
    border-radius: 7px;
}

.gestorSigemContenido{
    background: #f2f3f4;
}

.adminContenido{
    background: #ffffff;
    border-radius: 7px;
}

.border-derecho:not(:last-child){
    border-right: 1px solid gray;
}
textarea{
    width: 100%;
    height: 170px;
    padding:10px;
}
.bg-white-subtle{
    background-color: #ffffff;
    padding: 3px 7px;
}
.bg-dark-subtle{
    background-color: #e9ebec;
    padding: 3px 7px;
}
.bg-info-subtle{
    background-color: #95d6f7;
    padding: 3px 7px;
}

.bg-warn-subtle{
    background: rgb(236, 205, 152);
    padding: 3px 7px;
}

.bg-danger-subtle{
    background: rgb(235, 149, 167);
    padding: 3px 7px;
}

.bg-success-subtle{
    background: rgb(190, 241, 198);
    padding: 3px 7px;
}

.bg-info-subtle{
    background: rgb(162, 213, 250);
    padding: 3px 7px;
}
.gap-2{
    gap: .5rem;
}
.fullScreenModal{
    height: calc(100vh - 130px);
    overflow: auto;
    padding: 1rem;
}

/* Estilos para motores Webkit y blink (Chrome, Safari, Opera... )*/

.fullScreenModal::-webkit-scrollbar {
    -webkit-appearance: none;
}

.fullScreenModal::-webkit-scrollbar:vertical {
    width:10px;
}

.fullScreenModal::-webkit-scrollbar-button:increment,.fullScreenModal::-webkit-scrollbar-button {
    display: none;
} 

.fullScreenModal::-webkit-scrollbar:horizontal {
    height: 10px;
}

.fullScreenModal::-webkit-scrollbar-thumb {
    background-color: #cac9c9;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.fullScreenModal::-webkit-scrollbar-track {
    border-radius: 10px;  
}
</style>